<script setup>
import { defineEmits, defineProps, onMounted, onUnmounted, watch } from 'vue';

const props = defineProps({
    isVisible: { type: Boolean, default: false },
    title: { type: String, default: 'Информация' },
    closeOnOverlay: { type: Boolean, default: true },
    closeOnEsc: { type: Boolean, default: true },
});

const emit = defineEmits(['close']);

const close = () => emit('close');

const onOverlayClick = () => {
    if (!props.closeOnOverlay) return;
    close();
};

const onKeyDown = (e) => {
    if (!props.closeOnEsc) return;
    if (e.key === 'Escape') close();
};

const lockBody = () => {
    document.body.style.overflow = 'hidden';
};

const unlockBody = () => {
    document.body.style.overflow = '';
};

watch(
    () => props.isVisible,
    (visible) => {
        if (visible) {
            lockBody();
        } else {
            unlockBody();
        }
    },
    { immediate: true }
);

onMounted(() => {
    window.addEventListener('keydown', onKeyDown);
});

onUnmounted(() => {
    window.removeEventListener('keydown', onKeyDown);
    unlockBody(); // на всякий случай
});
</script>

<template>
    <transition name="fade">
        <div
            v-if="isVisible"
            class="custom-modal"
            role="dialog"
            aria-modal="true"
            @click.self="onOverlayClick"
        >
            <div class="custom-modal__content">
                <div class="custom-modal__close" @click="close" aria-label="Закрыть">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.0004 1L1 21M1 1L21.0004 21" stroke="black" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </div>
                <div class="custom-modal__body">
                    <slot />
                    <div
                        class="custom-modal__btn-close"
                        @click="close"
                    >
                        Закрыть
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
